import styled from 'styled-components';

export const PanelSettingsRow = styled.div`
  display: flex;
  > * {
    margin-right: 8px;
    :last-child {
      margin-right: 0px;
    }
  }
`;
